import React from 'react';
import styles from "@/page-components/verify/Banner/styles.module.less";

type TPcBanner = {
}
const PCBanner:React.FC<TPcBanner> = () => {
  return (
    <div className={styles.pc_banner_wrapper}>
      <div className={styles.pc_banner}>
        <div className={styles.title}>帆软职业资格认证查询</div>
        <div className={styles.english_title}>Fanruan Vocational Qualification Certification Inquiry</div>
        <div className={styles.subtitle}>可以查询自己考试证书及考试记录，也可用于用人单位核验证书真实性</div>
      </div>
    </div>
  )
}
export default PCBanner;
